// extracted by mini-css-extract-plugin
export default {"form":"LocationForm_form__Sz5ad","title":"LocationForm_title__Bw6tv","explanation":"LocationForm_explanation__OODHo","buttons":"LocationForm_buttons__5t1Cl"};